<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row align-items-center w-100">
          <div class="col">
            <h3 class="page-title text-gradient">Quản trị lương</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Khoản lương & Cấu hình NV</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- Tabs -->
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            :class="['nav-link', tab === 'KHOANG' ? 'active' : '']"
            href="#"
            @click.prevent="tab = 'KHOANG'"
          >
            Khoản lương (toàn công ty)
          </a>
        </li>
        <li class="nav-item">
          <a
            :class="['nav-link', tab === 'CONFIG' ? 'active' : '']"
            href="#"
            @click.prevent="tab = 'CONFIG'"
          >
            Cấu hình khoản theo nhân viên
          </a>
        </li>
      </ul>

      <div class="tab-content pt-3">
        <!-- ========== TAB 1: KHOẢN LƯƠNG ========== -->
        <div v-show="tab === 'KHOANG'">
          <div class="card shadow-soft">
            <div class="card-body">
              <div
                class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2"
              >
                <h5 class="card-title mb-0">Khoản lương công ty</h5>
                <div class="d-flex gap-2">
                  <select
                    class="form-control form-control-sm"
                    style="width: 180px"
                    v-model.number="khoang.filterTrangThai"
                    @change="fetchKhoangLuong"
                  >
                    <option :value="undefined">Tất cả trạng thái</option>
                    <option :value="1">Đang dùng (1)</option>
                    <option :value="0">Ẩn (0)</option>
                  </select>
                  <button
                    class="btn btn-sm btn-primary"
                    @click="openKhoangModal()"
                  >
                    <i class="fa fa-plus mr-1"></i> Tạo khoản
                  </button>
                </div>
              </div>

              <div class="table-responsive">
                <table
                  class="table table-striped custom-table table-nowrap mb-0"
                >
                  <thead>
                    <tr>
                      <th style="width: 60px">#</th>
                      <th style="min-width: 140px">Mã</th>
                      <th style="min-width: 220px">Tên khoản</th>
                      <th style="min-width: 160px">Loại</th>
                      <th>Mô tả</th>
                      <th style="min-width: 100px">Trạng thái</th>
                      <th class="text-right" style="min-width: 160px">
                        Hành động
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(it, idx) in khoang.list" :key="it.id">
                      <td>{{ idx + 1 }}</td>
                      <td>{{ it.maKhoang }}</td>
                      <td>{{ it.tenKhoang }}</td>
                      <td>
                        <span class="badge" :class="loaiBadgeClass(it.loai)">{{
                          mapLoai(it.loai)
                        }}</span>
                      </td>
                      <td class="text-muted">{{ it.moTa || "—" }}</td>
                      <td>
                        <span
                          :class="[
                            'badge',
                            it.trangThai === 1
                              ? 'badge-success'
                              : 'badge-secondary',
                          ]"
                        >
                          {{ it.trangThai === 1 ? "Đang dùng" : "Ẩn" }}
                        </span>
                      </td>
                      <td class="text-right">
                        <button
                          class="btn btn-sm btn-outline-primary mr-1"
                          @click="openKhoangModal(it)"
                        >
                          <i class="fa fa-pencil"></i>
                        </button>
                        <button
                          class="btn btn-sm btn-outline-danger"
                          @click="deleteKhoang(it)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="(khoang.list || []).length === 0">
                      <td colspan="7" class="text-center text-muted">
                        Chưa có khoản lương
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- ========== TAB 2: CẤU HÌNH NV ========== -->
        <div v-show="tab === 'CONFIG'">
          <div class="card shadow-soft">
            <div class="card-body">
              <div class="row align-items-end">
                <div class="col-md-3 mb-2">
                  <label class="small mb-1">Phòng ban</label>
                  <select
                    class="form-control form-control-sm"
                    v-model.number="cfg.filterPhongBanId"
                    @change="reloadUserOptions"
                  >
                    <option :value="undefined">— Tất cả —</option>
                    <option
                      v-for="pb in phongBan.options"
                      :key="pb.idPhongBan"
                      :value="pb.idPhongBan"
                    >
                      {{ pb.tenPhongBan }}
                    </option>
                  </select>
                </div>
                <div class="col-md-4 mb-2">
                  <label class="small mb-1">Nhân viên</label>
                  <select
                    class="form-control form-control-sm"
                    v-model.number="cfg.userId"
                    @change="fetchConfigByUser"
                  >
                    <option :value="undefined">— Chọn nhân viên —</option>
                    <option
                      v-for="u in users.options"
                      :key="u.idNguoiDung"
                      :value="u.idNguoiDung"
                    >
                      {{ u.hoTen || u.tenDangNhap }}
                    </option>
                  </select>
                </div>
                <div class="col-md-2 mb-2">
                  <label class="small mb-1">Tháng xem hiệu lực</label>
                  <input
                    type="month"
                    class="form-control form-control-sm"
                    v-model="cfg.monthStr"
                    @change="fetchConfigEffective"
                  />
                </div>
                <div class="col-md-3 mb-2 text-right">
                  <button
                    class="btn btn-sm btn-primary"
                    :disabled="!cfg.userId"
                    @click="openConfigModal()"
                  >
                    <i class="fa fa-plus mr-1"></i> Thêm cấu hình
                  </button>
                </div>
              </div>

              <div class="row mt-3">
                <div class="col-md-7">
                  <h6 class="mb-2">Tất cả cấu hình của NV</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered">
                      <thead class="thead-light">
                        <tr>
                          <th>#</th>
                          <th>Khoản</th>
                          <th>Phương thức</th>
                          <th>Giá trị/tháng</th>
                          <th>Hiệu lực</th>
                          <th>TT</th>
                          <th style="width: 120px">Hành động</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(it, i) in cfg.byUser" :key="it.id">
                          <td>{{ i + 1 }}</td>
                          <td>
                            <span class="badge badge-light">{{
                              it.maKhoang
                            }}</span>
                            — {{ it.tenKhoang }}
                          </td>
                          <td>
                            <span
                              class="badge"
                              :class="ptBadgeClass(it.phuongThucTinh)"
                              >{{ mapPhuongThuc(it.phuongThucTinh) }}</span
                            >
                          </td>
                          <td class="text-right">
                            {{ money(it.giaTriThang) }}
                          </td>
                          <td>
                            <div class="small text-muted">
                              {{ it.hieuLucTu }}
                              <span v-if="it.hieuLucDen"
                                >→ {{ it.hieuLucDen }}</span
                              >
                            </div>
                          </td>
                          <td>
                            <span
                              :class="[
                                'badge',
                                it.trangThai === 1
                                  ? 'badge-success'
                                  : 'badge-secondary',
                              ]"
                            >
                              {{ it.trangThai === 1 ? "ON" : "OFF" }}
                            </span>
                          </td>
                          <td>
                            <div class="btn-group btn-group-sm">
                              <button
                                class="btn btn-outline-primary"
                                @click="openConfigModal(it)"
                              >
                                <i class="fa fa-pencil"></i>
                              </button>
                              <button
                                class="btn btn-outline-danger"
                                @click="deleteConfig(it)"
                              >
                                <i class="fa fa-trash"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        <tr v-if="(cfg.byUser || []).length === 0">
                          <td colspan="7" class="text-center text-muted">
                            Chưa có cấu hình
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-md-5">
                  <h6 class="mb-2">Cấu hình hiệu lực tại tháng</h6>
                  <div class="table-responsive">
                    <table class="table table-sm table-striped">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Khoản</th>
                          <th>Phương thức</th>
                          <th class="text-right">Giá trị</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(it, i) in cfg.effective" :key="'ef' + i">
                          <td>{{ i + 1 }}</td>
                          <td>{{ it.tenKhoang }}</td>
                          <td>{{ mapPhuongThuc(it.phuongThucTinh) }}</td>
                          <td class="text-right">
                            {{ money(it.giaTriThang) }}
                          </td>
                        </tr>
                        <tr v-if="(cfg.effective || []).length === 0">
                          <td colspan="4" class="text-center text-muted">—</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ========== MODAL: KHOẢN LƯƠNG ========== -->
      <div v-if="khoang.modal.open">
        <div
          class="modal custom-modal fade show"
          style="display: block"
          role="dialog"
          aria-modal="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header border-0">
                <h5 class="modal-title">
                  {{
                    khoang.modal.form.id ? "Sửa khoản lương" : "Tạo khoản lương"
                  }}
                </h5>
                <button type="button" class="close" @click="closeKhoangModal">
                  <span>&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>Mã khoản</label>
                  <input
                    class="form-control"
                    v-model.trim="khoang.modal.form.maKhoang"
                    placeholder="VD: LUONG_CO_BAN"
                  />
                </div>
                <div class="form-group">
                  <label>Tên khoản</label>
                  <input
                    class="form-control"
                    v-model.trim="khoang.modal.form.tenKhoang"
                    placeholder="VD: Lương cơ bản"
                  />
                </div>
                <div class="form-group">
                  <label>Loại</label>
                  <select class="form-control" v-model="khoang.modal.form.loai">
                    <option
                      v-for="opt in LOAI_OPTIONS"
                      :key="opt.value"
                      :value="opt.value"
                    >
                      {{ opt.label }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Mô tả</label>
                  <textarea
                    class="form-control"
                    rows="2"
                    v-model.trim="khoang.modal.form.moTa"
                  ></textarea>
                </div>
                <div class="form-group">
                  <label>Trạng thái</label>
                  <select
                    class="form-control"
                    v-model.number="khoang.modal.form.trangThai"
                  >
                    <option :value="1">Đang dùng</option>
                    <option :value="0">Ẩn</option>
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-outline-secondary"
                  @click="closeKhoangModal"
                >
                  Huỷ
                </button>
                <button
                  class="btn btn-primary"
                  :disabled="khoang.saving || !khoangValid"
                  @click="saveKhoang"
                >
                  <span v-if="khoang.saving"
                    ><i class="fa fa-spinner fa-spin mr-1"></i> Đang lưu…</span
                  >
                  <span v-else>Lưu</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show"></div>
      </div>

      <!-- ========== MODAL: CẤU HÌNH NV ========== -->
      <div v-if="cfg.modal.open">
        <div
          class="modal custom-modal fade show"
          style="display: block"
          role="dialog"
          aria-modal="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header border-0">
                <h5 class="modal-title">
                  {{
                    cfg.modal.form.id ? "Sửa cấu hình NV" : "Thêm cấu hình NV"
                  }}
                </h5>
                <button type="button" class="close" @click="closeConfigModal">
                  <span>&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>Nhân viên</label>
                  <select
                    class="form-control"
                    v-model.number="cfg.modal.form.idNguoiDung"
                    :disabled="true"
                  >
                    <option :value="cfg.userId">
                      {{ currentUserLabel }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Khoản lương</label>
                  <select
                    class="form-control"
                    v-model.number="cfg.modal.form.idKhoangLuong"
                  >
                    <option
                      v-for="k in khoang.optionsActive"
                      :key="k.id"
                      :value="k.id"
                    >
                      {{ k.tenKhoang }} ({{ k.maKhoang }})
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Phương thức tính</label>
                  <select
                    class="form-control"
                    v-model="cfg.modal.form.phuongThucTinh"
                  >
                    <option
                      v-for="p in PHUONG_THUC_OPTIONS"
                      :key="p.value"
                      :value="p.value"
                    >
                      {{ p.label }}
                    </option>
                  </select>
                  <small class="text-muted">
                    - <b>Cố định</b>: luôn trả nguyên giá trị tháng.<br />
                    - <b>Theo ngày làm</b>: chia theo ngày làm thực tế của nhân
                    viên.
                  </small>
                </div>
                <div class="form-group">
                  <label>Giá trị/tháng (đ)</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="cfg.modal.form.giaTriThang"
                    min="0"
                    step="1000"
                  />
                </div>
                <div class="form-row">
                  <div class="form-group col">
                    <label>Hiệu lực từ</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="cfg.modal.form.hieuLucTu"
                    />
                  </div>
                  <div class="form-group col">
                    <label>Hiệu lực đến (tuỳ chọn)</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="cfg.modal.form.hieuLucDen"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label>Trạng thái</label>
                  <select
                    class="form-control"
                    v-model.number="cfg.modal.form.trangThai"
                  >
                    <option :value="1">ON</option>
                    <option :value="0">OFF</option>
                  </select>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-outline-secondary"
                  @click="closeConfigModal"
                >
                  Huỷ
                </button>
                <button
                  class="btn btn-primary"
                  :disabled="cfg.saving || !cfgValid"
                  @click="saveConfig"
                >
                  <span v-if="cfg.saving"
                    ><i class="fa fa-spinner fa-spin mr-1"></i> Đang lưu…</span
                  >
                  <span v-else>Lưu</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop fade show"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";

/** API ngay trong file .vue */
const api = axios.create({
  baseURL: process.env.VUE_APP_BASEURL,
  headers: {
    "Content-Type": "application/json",
    "ngrok-skip-browser-warning": "true",
  },
});
let isRefreshing = false;
let refreshWaitQueue = [];
function onRefreshed(newAccessToken) {
  refreshWaitQueue.forEach((cb) => cb(newAccessToken));
  refreshWaitQueue = [];
}
function addToQueue(cb) {
  refreshWaitQueue.push(cb);
}
api.interceptors.request.use((config) => {
  if (!config.url.includes("/auth/refresh")) {
    const token = localStorage.getItem("accessToken");
    if (token) config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config || {};
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise((resolve) =>
          addToQueue((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            resolve(api(originalRequest));
          })
        );
      }
      originalRequest._retry = true;
      isRefreshing = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken");
        const { data } = await axios.post(
          process.env.VUE_APP_BASEURL + "/api/auth/refresh",
          { refreshToken }
        );
        const newToken = data?.data?.accessToken || data?.accessToken;
        localStorage.setItem("accessToken", newToken);
        isRefreshing = false;
        onRefreshed(newToken);
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return api(originalRequest);
      } catch (e) {
        isRefreshing = false;
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default {
  name: "PayrollAdmin",
  data() {
    const y = new Date().getFullYear();
    const m = String(new Date().getMonth() + 1).padStart(2, "0");
    return {
      tab: "KHOANG",
      phongBan: { options: [] },
      users: { options: [] },

      khoang: {
        list: [],
        filterTrangThai: undefined,
        saving: false,
        modal: {
          open: false,
          form: {
            id: null,
            maKhoang: "",
            tenKhoang: "",
            loai: "PHU_CAP",
            moTa: "",
            trangThai: 1,
          },
        },
        optionsActive: [],
      },

      cfg: {
        filterPhongBanId: undefined,
        userId: undefined,
        monthStr: `${y}-${m}`,
        byUser: [],
        effective: [],
        saving: false,
        modal: {
          open: false,
          form: {
            id: null,
            idNguoiDung: null,
            idKhoangLuong: null,
            phuongThucTinh: "CO_DINH",
            giaTriThang: 0,
            hieuLucTu: "",
            hieuLucDen: "",
            trangThai: 1,
          },
        },
      },
    };
  },
  computed: {
    LOAI_OPTIONS() {
      return [
        { value: "CO_BAN", label: "Lương cơ bản" },
        { value: "PHU_CAP", label: "Phụ cấp" },
        { value: "KHAU_TRU", label: "Khấu trừ" },
      ];
    },
    PHUONG_THUC_OPTIONS() {
      return [
        { value: "CO_DINH", label: "Cố định" },
        { value: "THEO_NGAY", label: "Theo ngày làm thực tế" },
      ];
    },
    currentUserLabel() {
      const id = this.cfg.userId;
      const u = (this.users.options || []).find((x) => x.idNguoiDung === id);
      return u ? u.hoTen || u.tenDangNhap : "—";
    },
    // ✅ chặn lưu khi thiếu dữ liệu quan trọng
    cfgValid() {
      const f = this.cfg.modal.form || {};
      return !!(
        this.cfg.userId &&
        f.idKhoangLuong &&
        f.giaTriThang >= 0 &&
        f.hieuLucTu
      );
    },
    // chặn lưu khoản công ty thiếu mã/tên/loại
    khoangValid() {
      const f = this.khoang.modal.form || {};
      return !!(f.maKhoang && f.tenKhoang && f.loai);
    },
  },
  mounted() {
    this.fetchPhongBanOptions();
    this.reloadUserOptions();
    this.fetchKhoangLuong();
  },
  methods: {
    /* COMMON */
    money(v) {
      return Number(v || 0).toLocaleString("vi-VN") + " đ";
    },
    mapLoai(s) {
      const m = {
        CO_BAN: "Lương cơ bản",
        PHU_CAP: "Phụ cấp",
        KHAU_TRU: "Khấu trừ",
      };
      return m[s] || s || "—";
    },
    loaiBadgeClass(s) {
      if (s === "CO_BAN") return "badge-dark";
      if (s === "PHU_CAP") return "badge-success";
      if (s === "KHAU_TRU") return "badge-danger";
      return "badge-secondary";
    },
    // hỗ trợ cả THEO_NGAY & CHIA_NGAY_THUC_TE
    mapPhuongThuc(s) {
      const x = (s || "").toUpperCase();
      return x === "THEO_NGAY" || x === "CHIA_NGAY_THUC_TE"
        ? "Theo ngày làm"
        : "Cố định";
    },
    ptBadgeClass(s) {
      const x = (s || "").toUpperCase();
      return x === "THEO_NGAY" || x === "CHIA_NGAY_THUC_TE"
        ? "badge-info"
        : "badge-secondary";
    },

    async toastOK(title = "Thành công", text = "Đã lưu") {
      await Swal.fire({
        icon: "success",
        title,
        text,
        timer: 1200,
        showConfirmButton: false,
      });
    },
    async confirm(text = "Bạn chắc không?") {
      const r = await Swal.fire({
        icon: "warning",
        title: "Xác nhận",
        text,
        showCancelButton: true,
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Huỷ",
      });
      return r.isConfirmed;
    },

    /* OPTIONS */
    async fetchPhongBanOptions() {
      try {
        const { data } = await api.get("/api/phong-ban/options");
        this.phongBan.options = data?.data || [];
      } catch {
        this.phongBan.options = [];
      }
    },
    async reloadUserOptions() {
      try {
        const params = { limit: 200 };
        if (this.cfg.filterPhongBanId)
          params.phongBanId = this.cfg.filterPhongBanId;
        const { data } = await api.get("/api/nguoi-dung/options", { params });
        this.users.options = data || [];
      } catch {
        this.users.options = [];
      }
    },

    /* KHOẢN LƯƠNG */
    async fetchKhoangLuong() {
      try {
        const params = {};
        if (this.khoang.filterTrangThai !== undefined)
          params.trangThai = this.khoang.filterTrangThai;
        const { data } = await api.get("/api/khoang-luong", { params });
        this.khoang.list = data?.data || [];
        this.khoang.optionsActive = (this.khoang.list || []).filter(
          (x) => x.trangThai === 1
        );
      } catch {
        this.khoang.list = [];
        this.khoang.optionsActive = [];
      }
    },
    openKhoangModal(it) {
      this.khoang.modal.open = true;
      this.khoang.modal.form = it
        ? {
            id: it.id,
            maKhoang: it.maKhoang,
            tenKhoang: it.tenKhoang,
            loai: it.loai,
            moTa: it.moTa,
            trangThai: it.trangThai,
          }
        : {
            id: null,
            maKhoang: "",
            tenKhoang: "",
            loai: "PHU_CAP",
            moTa: "",
            trangThai: 1,
          };
    },
    closeKhoangModal() {
      this.khoang.modal.open = false;
    },
    async saveKhoang() {
      try {
        this.khoang.saving = true;
        const payload = { ...this.khoang.modal.form };
        await api.post("/api/khoang-luong/upsert", payload);
        await this.fetchKhoangLuong();
        this.closeKhoangModal();
        this.toastOK("Đã lưu khoản lương");
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Lưu thất bại",
          text: e?.response?.data?.message || "Vui lòng kiểm tra dữ liệu.",
        });
      } finally {
        this.khoang.saving = false;
      }
    },
    async deleteKhoang(it) {
      if (!(await this.confirm("Vô hiệu hoá khoản này?"))) return;
      try {
        await api.delete(`/api/khoang-luong/${it.id}`);
        await this.fetchKhoangLuong();
        this.toastOK("Đã vô hiệu hoá");
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Xoá thất bại",
          text: e?.response?.data?.message || "Không thể xoá",
        });
      }
    },

    /* CẤU HÌNH NV */
    async fetchConfigByUser() {
      this.cfg.byUser = [];
      this.cfg.effective = [];
      if (!this.cfg.userId) return;
      try {
        const { data } = await api.get(
          `/api/khoang-luong-nv/by-nv/${this.cfg.userId}`
        );
        this.cfg.byUser = data?.data || [];
        await this.fetchConfigEffective();
      } catch {
        this.cfg.byUser = [];
      }
    },
    async fetchConfigEffective() {
      this.cfg.effective = [];
      if (!this.cfg.userId || !this.cfg.monthStr) return;
      try {
        const y = Number(this.cfg.monthStr.substring(0, 4));
        const m = Number(this.cfg.monthStr.substring(5, 7));
        const params = { idNguoiDung: this.cfg.userId, thang: m, nam: y };
        const { data } = await api.get(
          "/api/khoang-luong-nv/hieu-luc-tai-thang",
          { params }
        );
        this.cfg.effective = data?.data || [];
      } catch {
        this.cfg.effective = [];
      }
    },
    openConfigModal(it) {
      if (!this.cfg.userId) return;
      this.cfg.modal.open = true;
      const base = {
        id: null,
        idNguoiDung: this.cfg.userId,
        idKhoangLuong: null,
        phuongThucTinh: "CO_DINH",
        giaTriThang: 0,
        hieuLucTu: "",
        hieuLucDen: "",
        trangThai: 1,
      };
      if (it) {
        this.cfg.modal.form = {
          id: it.id,
          idNguoiDung: it.idNguoiDung,
          idKhoangLuong: it.idKhoangLuong || it.id_khoang_luong,
          phuongThucTinh: it.phuongThucTinh,
          giaTriThang: it.giaTriThang,
          hieuLucTu: it.hieuLucTu,
          hieuLucDen: it.hieuLucDen,
          trangThai: it.trangThai,
        };
      } else {
        // ✅ default chọn khoản đầu tiên đang dùng để tránh null id
        const first = (this.khoang.optionsActive || [])[0];
        base.idKhoangLuong = first ? first.id : null;
        this.cfg.modal.form = base;
      }
    },
    closeConfigModal() {
      this.cfg.modal.open = false;
    },
    async saveConfig() {
      try {
        if (!this.cfgValid) {
          await Swal.fire({
            icon: "warning",
            title: "Thiếu dữ liệu",
            text: "Chọn khoản lương, nhập Giá trị/tháng và ngày Hiệu lực từ.",
          });
          return;
        }
        this.cfg.saving = true;
        const payload = { ...this.cfg.modal.form };
        await api.post("/api/khoang-luong-nv/upsert", payload);
        await this.fetchConfigByUser();
        this.closeConfigModal();
        this.toastOK("Đã lưu cấu hình");
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Lưu thất bại",
          text: e?.response?.data?.message || "Vui lòng kiểm tra dữ liệu.",
        });
      } finally {
        this.cfg.saving = false;
      }
    },
    async deleteConfig(it) {
      if (!(await this.confirm("Xoá cấu hình này?"))) return;
      try {
        await api.delete(`/api/khoang-luong-nv/${it.id}`);
        await this.fetchConfigByUser();
        this.toastOK("Đã xoá cấu hình");
      } catch (e) {
        Swal.fire({
          icon: "error",
          title: "Xoá thất bại",
          text: e?.response?.data?.message || "Không thể xoá",
        });
      }
    },
  },
};
</script>

<style scoped>
.shadow-soft {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}
.text-gradient {
  background: linear-gradient(90deg, #0d6efd, #20c997);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.nav-tabs .nav-link.active {
  font-weight: 600;
}
.badge {
  font-weight: 600;
}
</style>
